export default __webpack_public_path__ + "static/media/ce.a8023287.svg";